<template>
    <svg class="icon chevron" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.35998 1.13694L4.45544 -2.05486e-07L11.2 7L4.45544 14L3.35999 12.8631L9.00908 7L3.35998 1.13694Z" />
    </svg>    
</template>

<script>
    export default {}
</script>

<style scoped lang="sass">
    .chevron
        height: 14px
        width: 14px
        path
            transition: fill .15s ease-in

        +r(480)
            height: 12px
            width: 12px
</style>